import React from 'react';
import { Button, Space, Typography } from 'antd';
import { useConfirmation } from '../../providers/ConfirmationContext';
import TurnTimer from '../../features/dashboard/panels/TurnTimer/TurnTimer';
import styles from './CombatControls.module.css';

const { Text } = Typography;

interface CombatControlsProps {
  isActive: boolean;
  setupMode: boolean;
  round: number;
  turn: number;
  onSetup: () => void;
  onRollAll: () => void;
  onBegin: () => void;
  onNextTurn: () => void;
  onEnd: () => void;
  onLongRest: () => void;
}

const CombatControls: React.FC<CombatControlsProps> = ({
  isActive,
  setupMode,
  round,
  turn,
  onSetup,
  onRollAll,
  onBegin,
  onNextTurn,
  onEnd,
  onLongRest,
}) => {
  const { confirm } = useConfirmation();

  const handleEndCombat = () => {
    if (isActive) {
      confirm({
        message: 'Are you sure you want to end combat?',
        onConfirm: onEnd,
      });
    } else {
      onEnd(); // If only in setup mode, no confirmation needed
    }
  };

  const handleLongRest = () => {
    confirm({
      message: 'Are you sure you want the party to take a long rest? This will fully heal all party members.',
      onConfirm: onLongRest,
    });
  };

  const showSetup = !isActive && setupMode;
  const showActive = isActive && !setupMode;

  return (
    <Space wrap className={styles.controls} style={{ width: '100%' }}>
      {!showSetup && !showActive && (
        <>
          <Button type="primary" onClick={onSetup}>
            Setup Combat
          </Button>
          <Button onClick={handleLongRest}>Long Rest</Button>
        </>
      )}

      {showSetup && (
        <>
          <Button onClick={onRollAll}>Roll All Initiatives</Button>
          <Button type="primary" onClick={onBegin} className={styles.beginCombatBtn}>
            Begin Combat
          </Button>
        </>
      )}

      {showActive && (
        <>
          <Button type="primary" onClick={onNextTurn}>
            Next Turn (Round <Text strong style={{ color: 'inherit' }}>{round}</Text>)
          </Button>
          <TurnTimer turnKey={`${round}-${turn}`} />
        </>
      )}

      {(showSetup || showActive) && <Button danger onClick={handleEndCombat}>End Combat</Button>}
    </Space>
  );
};

export default CombatControls;